export const REACT_QUERIES_KEYS = {
  PROJECT: 'project',
  AUDITION: 'audition',
  AGENCY: 'agency',
  PROFILE_LINK: 'profileLink',
};
